<template>
  <Layout :hasBreadcrumbs="false">
    <div class="content">
      <div class="page-content">
        <MainTitle :title="this.$router.currentRoute.name" />
        <DHFData
          :approved="dashboardData.approvedcount"
          :active="dashboardData.activecount"
          :finished="dashboardData.finishedcount"
        />
        <div class="graphBox">
          <DHFStats
            :approved="dashboardData.approvedcountcurrmonth"
            :active="dashboardData.activecountcurrmonth"
            :finished="dashboardData.finishedcountcurrmonth"
            title="Current month's stats"
          />
          <DHFStats
            :approved="dashboardData.approvedcountprevmonth"
            :active="dashboardData.activecountprevmonth"
            :finished="dashboardData.finishedcountprevmonth"
            title="previous month's stats"
          />
          <DHFStats
            :approved="dashboardData.approvedcountcurryear"
            :active="dashboardData.activecountcurryear"
            :finished="dashboardData.finishedcountcurryear"
            title="current years stats"
          />
          <DHFStats
            :approved="dashboardData.approvedcountprevyear"
            :active="dashboardData.activecountprevyear"
            :finished="dashboardData.finishedcountprevyear"
            title="previous years stats"
          />
        </div>
        <!-- <DhrTable
          @selectedAmount="gotAmountToShow"
          @selectedRow="gotDHR"
          :DHRecords="DHRecords"
          :totalItems="amount.aantal"
          @sorting="gotSorting"
          @refresh="gotRefresh"
          :isEditable="true"
        /> -->
      </div>
      <!-- <div class="sidebar">
        <TableAction
          v-bind:hasButton="false"
          @clickedButton="gotClick"
          title="Add Raw Material"
          :isAdd="true"
        />
        <TableDetail
          v-if="this.selectedDHR"
          height="48"
          :details="this.selectedDHR"
        />
        <TblDetailQRcode
          v-if="this.selectedDHR"
          :details="this.selectedDHR"
          @refresh="gotRefresh"
        /> -->
      <!-- </div> -->
    </div>
  </Layout>
</template>

<script>
// @ is an alias to /src
import Layout from "@/layouts/Dashboard";
import MainTitle from "@/components/base/MainTitle";
import DHFData from "@/components/DHFData";
import Notifications from "@/components/Notifications";
import lowerSubparts from "@/components/lowerSubparts";
import DHFStats from "@/components/DHFStats";
import DhrTable from "@/components/TblDHR";
import TableAction from "@/components/TableAction";
import TableDetail from "@/components/TblDHRDetail";
import TblDetailQRcode from "@/components/TblDetailQRcode";
export default {
  name: "dashboard",
  data() {
    return {
      dashboardData: {},
      DHRecords: [],
      amount: 0,
      selectedDHR: null,
      pagina: 1,
      openModalHandler: false,
      sortingOn: "ref",
      isAscending: true,
      amountToShow: 8,
    };
  },
  components: {
    Layout,
    DhrTable,
    MainTitle,
    TableAction,
    TableDetail,
    TblDetailQRcode,
    DHFData,
    DHFStats,
  },
  mounted() {},
  beforeMount() {
    this.getDash();
  },

  methods: {
    getDash() {
      const that = this;
      this.$http
        .get(this.$endpoint + "production/dashboard/")
        .then((response) => {
          this.dashboardData = response.data;
          this.amount = 0;
          this.DHRecords = response.data.finishedcurrmonth;
          this.selectedDHR = null;
        })
        .catch((error) => {
          if (error.response === 401) {
            this.$store
              .dispatch("logout")
              .then(() => this.$router.push("/login"))
              .catch((err) => console.log(err));
          } else {
            that.$swal(
              "Oops that went wrong?",
              `Please contact the admin with the following info: ${error}`,
              "error"
            );
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sidebar.scss";
/* 
.sidebar {
  background-color: red;
} */

.graphBox {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
</style>;
